"use strict";
// PotLimit.ts
//
// Checks whether the current bet is bigger than the pot size
Object.defineProperty(exports, "__esModule", { value: true });
exports.PotLimit = void 0;
const BettingStructure_1 = require("./BettingStructure");
/**
 * Pot Limit
 *
 * The limit each player can put is the amount in the pot
 */
class PotLimit extends BettingStructure_1.BettingStructure {
    validateBet(bet, round) {
        var _a;
        this.validatePositiveNumber(bet.amount, "bet amount");
        const currentPot = (_a = round.currentPot) !== null && _a !== void 0 ? _a : 0;
        if (bet.amount > currentPot) {
            throw new Error(`Current bet amount of ${bet.amount} will exceed exceed the current pot of ${round.currentPot}`);
        }
        this.validateRaises(bet, round);
    }
}
exports.PotLimit = PotLimit;
//# sourceMappingURL=PotLimit.js.map